import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import classes from "./Filter.module.css";
import { options, statusFilterItems } from "../../../constants/utils";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { filterStatusReducer } from "../../../Redux/Slice/FilterSlice";

const StatusFilter = ({
  statusItemHandler = () => {},
  isStatusItemClicked,
}) => {
  const dispatch = useDispatch();
  const filterStatus = useSelector((state) => state.FilterSlice.filterStatus);
  return (
    <Box>
      {statusFilterItems.map((option) => (
        <Typography
          className={classes["statusFilterStyle"]}
          onClick={() => {
            statusItemHandler(option.label);
            dispatch(filterStatusReducer(option.label));
          }}
          sx={{
            backgroundColor: option.label === filterStatus ? "red" : "#FAFAFA;",
            color: option.label === filterStatus ? "white" : "black",
          }}
        >
          {option.label}
        </Typography>
      ))}
    </Box>
  );
};

StatusFilter.propTypes = {
  statusItemHandler: PropTypes.func,
};
export default StatusFilter;
